import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const RutaProtegida = () => {
  const { usuario, cargando } = useAuth();

  if (cargando) return <p>Cargando...</p>;
  return usuario ? <Outlet /> : <Navigate to="/admin" />;
};

export default RutaProtegida;
